<template>
  <div>
    <div class="content">
      <LoginLogo />

      <v-form v-if="!passwordChanged" ref="form" v-on:submit.prevent="resetPassword">
        <v-container>
          <v-row>
            <v-text-field
              v-model="email"
              v-bind:rules="emailRules"
              v-bind:error-messages="emailErrors"
              label="Email Address"
              variant="solo-filled" flat block required
            >
            </v-text-field>
          </v-row>

          <v-row v-if="hasCode">
            <v-text-field
                v-model="code"
                v-bind:rules="codeRules"
                v-bind:error-messages="codeErrors"
                label="code"
                variant="solo-filled" flat block required
            >
            </v-text-field>

            <v-alert color="blue" variant="outlined" text type="info">
              A verification code has been sent to your email. Please enter it in the field above to continue.
            </v-alert>
          </v-row>
          <v-row>
            <v-btn type="submit" class="bg-primary" block>
              {{ hasCode ? 'Reset Password' : 'Send Code' }}
            </v-btn>
          </v-row>
        </v-container>
      </v-form>

      <v-row v-if="passwordChanged">
        <v-alert color="success" variant="outlined" text type="success">
          We have sent a new temporary password to your email address. Please use it to log in and consider updating it to a strong, unique password.
        </v-alert>
      </v-row>
    </div>

    <div class="text-center mt-5">
      <router-link to="/account/login">Return to login page</router-link>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '@/stores/UserStore.js'
import LoginLogo from './components/LoginLogo.vue';
import Helper from '@/components/helper.js';

export default {
  name: 'ResetTemporaryPassword',
  components: {
    LoginLogo,
  },
  data: function() {
    return {
      email: "",
      emailErrors: [],
      emailRules: [
        v => !!v || 'Please, enter email address.',
        v => Helper.isEmailValid(v) || 'Please, enter valid email address.',
      ],

      code: "",
      hasCode: false,
      codeErrors: [],
      codeRules: [
        v => !!v || 'Please, enter code.',
      ],

      passwordChanged: false,
    };
  },
  mounted: function() {
    this.email = this.$route.params.email || '';
  },
  methods: {
    resetPassword: async function() {
      const validForm = await this.$refs.form.validate();
      if (!validForm.valid) {
        return;
      }

      const params = {
        email: this.email,
      };

      try {
        const userStore = useUserStore();

        let response;
        if (this.code) {
          params.code = this.code;
          response = await userStore.resetTemporaryPassword(params);
        } else {
          response = await userStore.sendTemporaryPasswordCode(params);
        }

        console.log('response', response);

        if (response?.codeSent === true) {
          this.hasCode = true;
        }

        if (response?.passwordChanged === true) {
          this.code = '';
          this.hasCode = false;
          this.passwordChanged = true;
        }
      } catch (e) {
        console.error(e.message);
      }
    }
  }
}
</script>

<style>

</style>
